import React from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

/**
 * Page shown when user tries to access a route they don't have permission for
 */
const Unauthorized = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-column align-items-center justify-content-center p-5" style={{ minHeight: '70vh' }}>
      <div className="text-center">
        <i className="pi pi-exclamation-triangle text-6xl mb-4" style={{ color: '#FF556A' }}></i>
        <h1 className="text-4xl font-bold mb-4">Access Denied</h1>
        <p className="text-xl mb-5">You don't have permission to access this page.</p>
        <Button 
          label="Return to Dashboard" 
          icon="pi pi-home" 
          onClick={() => navigate('/')}
          style={{ backgroundColor: '#FF556A', border: 'none' }}
        />
      </div>
    </div>
  );
};

export default Unauthorized;